import ozBaseAmenities from '@/components/oz-base-amenities'

import cardMixin from '@/components/oz-card/oz-card-mixin'

import { priceIsLowerThanExpected } from '@/utils/listing'

import { URLS, LISTING } from '@/utils/constants'
import DATA_ZAP_HASH from '@/lib/constants/url'
import datazapTracker from '@/pages/datazap/datazap.tracker'
import DATAZAP_ACTIONS from '@/pages/datazap/constants'

import ozFavorite from '@/components/oz-favorite'
import ozCardImage from '../oz-card-image'
import ozCardPrices from '../oz-card-prices'
import ozCardModalCta from '../oz-card-modal-cta'

import TYPES_MAP from '../constants'

import {
  IMAGE_REGULAR_SIZE,
  DESCRIPTION_MAX_LENGTH,
  UNIT_TYPES_DATAZAP_APPROVED,
} from './constants'

export default {
  name: 'oz-card-listing',

  mixins: [cardMixin],

  props: {
    doublePhoto: { type: Boolean, default: false },
    positionRanking: { type: Number },
    showFavoriteButton: { type: Boolean, default: true },
    type: { type: String, default: 'card' },
    isLeadPhoneModalVariation: { type: Boolean },
    index: { type: Number },
  },

  computed: {
    isDiamond () {
      return this.listing.publicationType === 'PREMIERE_1'
    },

    isPlatinum () {
      return this.listing.publicationType === 'PREMIERE_2'
    },

    showDescription () {
      return this.descriptionText
    },

    descriptionText () {
      const { description = '' } = this.listing

      if (description.length > DESCRIPTION_MAX_LENGTH) {
        const textWithoutBRTag = description.replace(/(?:<|&lt;)\s?br\s?\/?(?:>|&gt;)/gm, ' ')
        return textWithoutBRTag.substr(0, DESCRIPTION_MAX_LENGTH).trim().concat('...')
      }

      return description
    },

    containerCardClass () {
      const { isDiamond, isPlatinum } = this

      return {
        'card-container js-listing-card': true,
        'card-container__diamond': isDiamond,
        'card-container__platinum': isPlatinum,
      }
    },

    cardClass () {
      return {
        'card-listing simple-card': true,
        'card-listing--expanded': this.descriptionOpened,
        'card-listing--inactive': this.listing.isDefaulterInactive,
        'card-listing--link': this.shouldRenderAsLink,
        'card-listing--selected': this.selected,
      }
    },

    sizeResponsive () {
      return { imageSize: IMAGE_REGULAR_SIZE.desktop }
    },

    isCollapsible () {
      return this.descriptionText.length > 70
    },

    datazapApproved () {
      const { VALUE_STAMPS } = LISTING
      return this.stamps?.includes(VALUE_STAMPS[this.businessTypeContext])
    },

    unitTypeDatazap () {
      return UNIT_TYPES_DATAZAP_APPROVED.includes(this.listing.unitTypes[0])
    },

    cardComponentProps () {
      return this.shouldRenderAsLink ? {
        to: this.$getUrl,
        href: new URL(this.$getUrl.path, URLS.ZAP_URL).href,
        target: '_blank',
        is: 'router-link',
        rel: 'noopener',
      } : {
        is: 'div',
      }
    },

    datazapRangePosition () {
      return priceIsLowerThanExpected(this.listing) ? 'abaixo' : 'dentro'
    },

    listingPosition () {
      return this.index + 1
    },

    currentPage () {
      return this.results?.pagination?.currentPage
    },

    cardType () {
      return TYPES_MAP[this.type.toUpperCase()]
    },
  },

  methods: {
    toggleDescription () {
      this.descriptionOpened = !this.descriptionOpened
    },

    goToDatazapLDP (event) {
      datazapTracker.datazapClicked({ action: DATAZAP_ACTIONS.GO_TO_PAGE })

      this.goTo(event, {
        newTab: true,
        action: 'SEE DETAILS',
        hash: DATA_ZAP_HASH,
      })
    },

    openLDP (e) {
      this.goTo(e, {
        newTab: true,
        action: 'SEE DETAILS',
      })
    },

    onClickCard (e) {
      if (this.shouldRenderAsLink) {
        return this.track('SEE DETAILS')
      }

      return this.openLDP(e)
    },
  },

  components: {
    ozBaseAmenities,
    ozCardImage,
    ozCardPrices,
    ozCardModalCta,
    ozFavorite,
  },
}
